var THREEx = require('particlespace-dom-events');

module.exports=THREEx;



//////////////////
// WEBPACK FOOTER
// ./~/particlespace-graphics-engine-extensions/index.js
// module id = 390
// module chunks = 0